module.exports = __webpack_public_path__ + "img/图标4.61016caa.png";